import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { SearchWrapper, SelectWrapper } from '../../Admin/DashBoard/dashBoardStyled'
import { AiOutlineSearch, AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import Spinner from '../../../../components/Spinner'
import { addminUserActivityList, setUserInfoDetails } from '../../../../../redux/actions/admin';
import styled from 'styled-components';
import CsvDownloader from 'react-csv-downloader';

//table
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';

import { Form, Formik, Field } from 'formik';
import { Button, } from 'reactstrap';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'

import { stateConvert } from 'web/components/utils/stateAbbreviation';
import CheckboxInput from "web/components/form-elements/CheckboxInput";

import { getAllStatesOfCountry, getAllCitiesOfState } from "helpers";

function UserActivity() {
  const dispatch = useDispatch();
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessaage] = useState('')
  const [loadScreen, setLoadScreen] = useState(false);
  const [tableSearch, setTableSearch] = useState('')
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [filterDataList, setFilterDataList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [finalData, setFinalData] = useState([])
  const [csvData, setCsvData] = useState([])
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 30);
  const [userFilterState, setUserFilterState] = useState({
    state: 'All',
    city: 'All',
    dateFilter: 'thirty',
    fromDate: fromDate.toISOString().substr(0, 10),
    toDate: toDate.toISOString().substr(0, 10),
    excludeZeroActivity: false,
    sortState: 'normal'
  })

  const states = getAllStatesOfCountry('US').map((state) => ({
    value: state.name,
    label: `${state.isoCode}-${state.name}`,
    isoCode: state.isoCode
  }));
  const currentState = states.find((c) => c.value === userFilterState.state)?.isoCode || '';
  const filterCities = getAllCitiesOfState(currentState, 'US')
    ?.map((city) => ({ value: city, label: city })) ?? [];

  const dateFilterOptions = [
    { value: 'seven', label: 'Last 7 days' },
    { value: 'thirty', label: 'Last 30 days' },
    { value: 'ninety', label: 'Last 90 days' },
    { value: 'custom', label: 'Custom Date' }
  ];

  const handleFilterStateChange = (e) => {
    setPage(1)
    const { id, value } = e.target
    setUserFilterState(prevState => ({
      ...prevState,
      [id]: value
    }))
    if (id === 'state') {
      setUserFilterState(prevState => ({
        ...prevState,
        city: 'All'
      }))
    }
    if (id === 'dateFilter') {
      if (value != 'custom') {
        let toDate = new Date();
        let fromDate = new Date();
        if (value === 'seven') fromDate.setDate(fromDate.getDate() - 7)
        else if (value === 'thirty') fromDate.setDate(fromDate.getDate() - 30)
        else if (value === 'ninety') fromDate.setDate(fromDate.getDate() - 90)
        setUserFilterState(prevState => ({
          ...prevState,
          fromDate: fromDate.toISOString().substr(0, 10),
          toDate: toDate.toISOString().substr(0, 10)
        }))
      }
    }
    if (id === 'state') filterDataFunction(value, 'All', userFilterState.excludeZeroActivity, tableSearch, undefined, userFilterState.sortState)
    if (id === 'city') filterDataFunction(userFilterState.state, value, userFilterState.excludeZeroActivity, tableSearch, undefined, userFilterState.sortState)
  }

  const setSortState = (type) => {
    let nextType = ''
    if (type === 'normal') nextType = 'ascend'
    if (type === 'ascend') nextType = 'descend'
    if (type === 'descend') nextType = 'normal'
    setUserFilterState(prevState => ({
      ...prevState,
      sortState: nextType
    }))
    filterDataFunction(userFilterState.state, userFilterState.city, userFilterState.excludeZeroActivity, tableSearch, undefined, nextType)
  }

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchMyAPI()
  }, [userFilterState.dateFilter]);

  const fetchMyAPI = async (type) => {
    if (type === 'custom' || userFilterState.dateFilter !== 'custom') {
      let response = '';
      let data = {
        startDate: moment(userFilterState.fromDate).format('YYYY-MM-DD'),
        endDate: moment(userFilterState.toDate).format('YYYY-MM-DD')
      }
      response = await dispatch(addminUserActivityList(data));
      setLoadScreen(true)
      if (response?.data?.userActivityResponse) {
        // let adminUserActivityDataListTemp = response.data.userActivityResponse
        let adminUserActivityDataListTemp = [...response.data.userActivityResponse, ...response.data.userActivityResponseWithOutData]
        let adminUserActivityDataList = adminUserActivityDataListTemp.map(data => {
          return {
            ...data,
            locationStatus: data.locationStatus ? 'Activated' : 'De-Activated',
            emailCheckBox: false
          }
        })

        setDataList(adminUserActivityDataList)
        filterDataFunction(userFilterState.state, userFilterState.city, userFilterState.excludeZeroActivity, tableSearch, adminUserActivityDataList, userFilterState.sortState)
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalMessaage(response.data?.message || response.message || 'Error occured, Please try again!')
          setModal(!modal)
        }
      }
    }
  };

  const setCSVDate = (adminUserActivityDataList) => {
    let tempCsvData = adminUserActivityDataList.map(items => {
      return ({
        CompanyName: items.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        CompanyCityState: `${items.companyCity?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")?.trim()}- ${stateConvert(items.companyState?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "))}`,
        NeedPosts: !isNaN(items.postNeedCount) ? items.postNeedCount : '-',
        BuyerOrders: !isNaN(items.orderPurchasedCount) ? items.orderPurchasedCount : '-',
        // BuyerOrdersPercent: (!isNaN((items.orderPurchasedCount / items.postNeedCount)?.toFixed(2)) && items.postNeedCount !== 0) ?
        //     (items.orderPurchasedCount / items.postNeedCount)?.toFixed(2) : '-',
        InventoryPosts: !isNaN(items.postInventoryCount) ? items.postInventoryCount : '-',
        SellerOrders: !isNaN(items.orderSoldCount) ? items.orderSoldCount : '-',
        // SellerOrdersPercent: (!isNaN((items.orderSoldCount / items.postInventoryCount)?.toFixed(2)) && items.postInventoryCount !== 0) ?
        //     ((items.orderSoldCount / items.postInventoryCount)?.toFixed(2)) : '-',
        TotalOrders: !isNaN(items.orderPurchasedCount + items.orderSoldCount) ? (items.orderPurchasedCount + items.orderSoldCount) : '-',
        LastOrderDate: items.lastOrderDate ? moment(items.lastOrderDate).format("MM/DD/YYYY") : '',
        Status: items.locationStatus?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ")
      })
    })
    setCsvData(tempCsvData)
  }

  const searchResultData = (dataList, search) => {
    let dataListtemp = dataList.filter(value => {
      return (
        value.companyName?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.companyCity?.toString().toLowerCase().includes(search.toLowerCase()) ||
        stateConvert(value.companyState)?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.postNeedCount?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.orderPurchasedCount?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.postInventoryCount?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.orderSoldCount?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.lastOrderDate?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.locationStatus?.toString().toLowerCase().includes(search.toLowerCase())
      )
    });
    return dataListtemp
  }

  const handleChange = (event, value) => {
    setPage(value);
    let dataListtemp = JSON.parse(JSON.stringify(filterDataList))
    let pageData = JSON.parse(JSON.stringify(dataListtemp))
    setFinalData(pageData.splice(value * 10 - 10, 10))
  };

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    const search = e.target.value
    filterDataFunction(userFilterState.state, userFilterState.city, userFilterState.excludeZeroActivity, search, undefined, userFilterState.sortState)
  }

  // table header
  let headerArr = [
    { title: 'Company City, ST', },
    { title: 'Need Posts', },
    { title: 'Buyer Orders', },
    // { title: 'Buyer Order Percent', },
    { title: 'Inventory Posts', },
    { title: 'Seller Orders', },
    // { title: 'Seller Order Percent', },
    { title: 'Total Orders', },
    { title: 'Last Order Date', },
    { title: 'Status', },
  ];

  //for csv download
  const columns = [
    { id: 'CompanyName', displayName: 'Company Name' },
    { id: 'CompanyCityState', displayName: 'Company City & ST' },
    { id: 'NeedPosts', displayName: 'Need Posts' },
    { id: 'BuyerOrders', displayName: 'Buyer Orders' },
    // { id: 'BuyerOrdersPercent', displayName: 'Buyer Order Percent' },
    { id: 'InventoryPosts', displayName: 'Inventory Posts' },
    { id: 'SellerOrders', displayName: 'Seller Orders' },
    // { id: 'SellerOrdersPercent', displayName: 'Seller Order Percent' },
    { id: 'TotalOrders', displayName: 'Total Orders' },
    { id: 'LastOrderDate', displayName: 'Last Order Date' },
    { id: 'Status', displayName: 'Status' }
  ]

  const selectStyle = {
    maxWidth: '250px'
  }

  const handleToggle = () => {
    setModal(false)
  }

  const INITIAL_VALUES = {
    excludeZeroActivity: false
  };
  const VALIDATION_SCHEMA = () => {
  }

  const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

  const filterDataFunction = (state, city, zeroActivityCheck, searchWord, dataListArray, sortType) => {
    let wholeData
    if (dataListArray) wholeData = dataListArray
    else wholeData = JSON.parse(JSON.stringify(dataList))

    let filterResult = searchResultData(wholeData, searchWord)
    if (state !== 'All') filterResult = filterResult.filter(val => val.companyState === state)
    if (city !== 'All') filterResult = filterResult.filter(val => val.companyCity === city)
    if (zeroActivityCheck) filterResult = filterResult.filter(val => (val.postNeedCount > 0 || val.orderPurchasedCount > 0 || val.postInventoryCount > 0 || val.orderSoldCount > 0))
    if (sortType === 'ascend') filterResult = filterResult.sort((a, b) => {
      if (a.companyName < b.companyName) return -1;
      if (a.companyName > b.companyName) return 1;
      return 0;
    });
    if (sortType === 'descend') filterResult = filterResult.sort((a, b) => {
      if (a.companyName > b.companyName) return -1;
      if (a.companyName, b.companyName) return 1;
      return 0;
    });

    setPage(1)
    if (filterResult.length % 10 === 0) {
      setPageCount(filterResult.length / 10)
    } else {
      setPageCount(Math.trunc(filterResult.length / 10) + 1)
    }

    let tempSearchData = JSON.parse(JSON.stringify(filterResult))
    setFilterDataList(tempSearchData)
    setFinalData(filterResult.splice(0, 10))

    //set csv data
    setCSVDate(tempSearchData)
  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('USERACTIVITY_ADMIN'))) ?
        <TableWrapper>
          {loaderVisible && <Spinner />}
          <div class="column">
            <Heading>
              <h3>USER ACTIVITY</h3>
              <div className='d-flex flex-wrap flex-sm-nowrap'>
                <SearchWrapper>
                  <input type="text" placeholder='Search' value={tableSearch}
                    onChange={handleSearchChange} />
                  <AiOutlineSearch />
                </SearchWrapper>
                <CsvDownloader
                  filename="User Activity Report"
                  columns={columns}
                  datas={csvData}>
                  <button
                    style={buttonStyle}>
                    Export
                  </button>
                </CsvDownloader>
              </div>
            </Heading>
            <InnerHeader>
              <SelectWrapper>
                <label>State</label>
                <select style={selectStyle} id='state' value={userFilterState.state} onChange={handleFilterStateChange}>
                  <option value='All'>All</option>
                  {
                    states.map((data, index) => {
                      return <option value={data.value}>{data.label}</option>
                    })
                  }
                </select>
              </SelectWrapper>
              <SelectWrapper>
                <label>City</label>

                <select style={selectStyle} id='city' value={userFilterState.city} onChange={handleFilterStateChange}>
                  <option value='All'>All</option>
                  {
                    filterCities.map((data, index) => {
                      return <option value={data.label}>{data.label}</option>
                    })
                  }
                </select>
              </SelectWrapper>

              <SelectWrapper>
                <label>Filter By</label>
                <select style={selectStyle} id='dateFilter' value={userFilterState.dateFilter} onChange={handleFilterStateChange} >
                  {
                    dateFilterOptions.map((data, index) => {
                      return <option value={data.value}>{data.label}</option>
                    })
                  }
                </select>
              </SelectWrapper>
              {userFilterState.dateFilter === 'custom' &&
                <>
                  <SelectWrapper>
                    <label>From</label>
                    <input type='date' max={userFilterState.toDate} id='fromDate' value={userFilterState.fromDate} onChange={handleFilterStateChange} />
                  </SelectWrapper>
                  <SelectWrapper>
                    <label>To</label>
                    <input type='date' min={userFilterState.fromDate} max={toDate.toISOString().substr(0, 10)} id='toDate' value={userFilterState.toDate} onChange={handleFilterStateChange} />
                  </SelectWrapper>
                  <button
                    style={buttonStyle}
                    onClick={() => fetchMyAPI('custom')}>
                    Submit
                  </button>
                </>
              }
            </InnerHeader>
            <div style={{ marginLeft: '22px' }}>
              <Formik
                initialValues={INITIAL_VALUES}
                validationSchema={VALIDATION_SCHEMA()}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const { isValid, dirty, values, errors, touched } = props;
                  return (
                    <>
                      <Form>
                        <CheckboxInput
                          name="excludeZeroActivity"
                          label="Exclude Zero Activity"
                          handleSelect={(name, label, flag) => {
                            setUserFilterState(prevState => ({
                              ...prevState,
                              excludeZeroActivity: flag
                            }))
                            filterDataFunction(userFilterState.state, userFilterState.city, flag, tableSearch, undefined, userFilterState.sortState)
                          }}
                        />
                      </Form>
                    </>
                  );
                }}
              </Formik>
            </div>
          </div>
          <Table responsive>
            <thead>
              <tr>
                <th>Company Name
                  {userFilterState.sortState === 'normal' ?
                    <AiOutlineVerticalAlignMiddle onClick={() => setSortState('normal')} style={{ height: '22px', width: '28px', color: '#61b01f' }} /> :
                    userFilterState.sortState === 'ascend' ?
                      <AiOutlineArrowDown onClick={() => setSortState('ascend')} style={{ height: '22px', width: '28px', color: '#61b01f' }} /> :
                      <AiOutlineArrowUp onClick={() => setSortState('descend')} style={{ height: '22px', width: '28px', color: '#61b01f' }} />}
                </th>
                {headerArr.map((items, index) => (
                  <th key={index}>{items.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {
                finalData.map((items, index) => (
                  <tr key={index}>
                    <td>{items.companyName}</td>
                    <td>{`${items.companyCity?.trim()}, ${stateConvert(items.companyState)}`}</td>
                    <td>{!isNaN(items.postNeedCount) ? items.postNeedCount : '-'}</td>
                    <td>{!isNaN(items.orderPurchasedCount) ? items.orderPurchasedCount : '-'}</td>
                    {/* <td>
                                                {(!isNaN(((items.orderPurchasedCount / items.postNeedCount) * 100)?.toFixed(2)) && items.postNeedCount !== 0) ?
                                                    ((items.orderPurchasedCount / items.postNeedCount) * 100)?.toFixed(2) : '-'}
                                            </td> */}
                    <td>{!isNaN(items.postInventoryCount) ? items.postInventoryCount : '-'}</td>
                    <td>{!isNaN(items.orderSoldCount) ? items.orderSoldCount : '-'}</td>
                    {/* <td>
                                                {(!isNaN(((items.orderSoldCount / items.postInventoryCount) * 100)?.toFixed(2)) && items.postInventoryCount !== 0) ?
                                                    (((items.orderSoldCount / items.postInventoryCount) * 100)?.toFixed(2)) : '-'}
                                            </td> */}
                    <td>{!isNaN(items.orderPurchasedCount + items.orderSoldCount) ? (items.orderPurchasedCount + items.orderSoldCount) : '-'}</td>
                    <td>{items.lastOrderDate ? moment(items.lastOrderDate).format("MM/DD/YYYY") : ''}</td>
                    <td>{items.locationStatus}</td>
                  </tr>
                ))}
              {loadScreen && finalData.length === 0 &&
                <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '40px' }}>No records found</p>
              }
            </tbody>
          </Table>

          {finalData.length !== 0 && <Pagination count={pageCount}
            page={page}
            onChange={handleChange} />}

        </TableWrapper>
        :
        <p>You are not authorized to view this page.</p>
      }
      <Modal isOpen={modal} centered={true}>
        <ModalBody style={{ textAlign: 'center' }}>
          {modalMessage}
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center' }}>
          <Button color="primary" onClick={handleToggle}>OK</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default UserActivity

const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 0 20px;
    align-items: flex-end;
    border-bottom: solid 1px #97979729;
    padding: 0 20px;
    gap: 10px;
    padding-bottom: 15px;
    flex-wrap: wrap;
`
